import { render, staticRenderFns } from "./TaskEventTabs.vue?vue&type=template&id=5abd212f&"
import script from "./TaskEventTabs.vue?vue&type=script&lang=js&"
export * from "./TaskEventTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports